// extracted by css-extract-rspack-plugin
export default {"sortIconText":"column-sort-icon-module__sortIconText__YxUjue3"};